import React, { useState } from 'react'


import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

import MenuButtonItems from './MenuButtonItems'

const useStyles = makeStyles(theme => ({
  
}))

const MenuButton = ({
  title,
  icon,
  buttonProps,
  items,
  disabled,
}) => {
  const classes = useStyles()
  const [ anchorEl, setAnchorEl ] = useState(null)

  const handleMenu = event => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  const ButtonIcon = icon

  return (
    <div className={ classes.root }>
      <Button
        onClick={ handleMenu }
        disabled={ disabled }
        {...buttonProps}
      >
        { title }
        { ButtonIcon && (
          <ButtonIcon />
        ) }
      </Button>

      <MenuButtonItems
        anchorEl={ anchorEl }
        items={ items }
        onClose={ handleClose }
      />        
    </div>
  )
}

export default MenuButton